export default "<i class=\"fas fa-dot-circle fa-fw\" [ngStyle]=\"{color:color }\"></i>"